import { purchaseProcess } from "../../content/process";

export function PurchaseFlow() {
  return (
    <section
      id="flow"
      className="purchase-flow section section--compact section--sand"
      data-review-region="timed-purchase-flow"
      aria-labelledby="purchase-flow-title"
    >
      <div className="section-shell">
        <div className="section-intro">
          <p className="section-kicker">お問い合わせから完了まで</p>
          <h2 id="purchase-flow-title">廃車買取の流れ</h2>
          <p>
            電話査定から車両の引き取り、現金でのお支払い、抹消手続きまで松島オートが対応します。
          </p>
        </div>

        <ol
          className="purchase-flow__list"
          data-auth-signature="matsushima-tow-line"
        >
          {purchaseProcess.map((step) => {
            const [title, timing] = step.title.split("：");

            return (
              <li className={`purchase-flow__item purchase-flow__item--${step.kind}`} key={step.number}>
                <span className="purchase-flow__number" aria-hidden="true">
                  {step.number}
                </span>
                <div className="purchase-flow__body">
                  <h3>
                    <span>{title}</span>
                    {timing ? (
                      <>
                        <span aria-hidden="true">：</span>
                        <strong>{timing}</strong>
                      </>
                    ) : null}
                  </h3>
                  <p>{step.description}</p>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
